import { gql } from '@apollo/client'

export const GET_DASHBOARD_CONFIG = gql`
  query GetDashboard($key: String!) {
    dashboard(key: $key) {
      token,
      kind,
      url
    }
  }
`